import type { CrewListMember, TabKey } from "./crew.types";

const AUTHORITY_ROLES = ["OWNER", "SKIPPER", "ADMIN", "INSTRUCTOR"] as const;

export function filterCrew(data: CrewListMember[], tab: TabKey, search: string): CrewListMember[] {
  let result = data;
  switch (tab) {
    case "at-sea":
      result = result.filter((m) => m.user.crewMemberships.some((cm) => cm.expedition.status === "ACTIVE"));
      break;
    case "skippers":
      result = result.filter((m) => m.roles.includes("SKIPPER"));
      break;
    case "instructors":
      result = result.filter((m) => m.roles.includes("INSTRUCTOR"));
      break;
    case "crew":
      result = result.filter((m) => !m.roles.some((r) => (AUTHORITY_ROLES as readonly string[]).includes(r)));
      break;
  }
  if (search.trim()) {
    const q = search.toLowerCase();
    result = result.filter((m) => m.user.displayName.toLowerCase().includes(q));
  }
  return result;
}
